module.exports = "/images/Widgets.svg?e06995f07573b4a633319111344a7ece";